require('../../../vendor/angular-ux-datagrid.vendor.js');
require('bootstrap');
require('summernote/dist/summernote.css');
require('summernote/dist/summernote.js');
require('angular-summernote');
require('ace-builds/src-noconflict/ace');
require('ace-builds/webpack-resolver');
require('angular-ui-ace/src/ui-ace');

angular.module('ums.configuration', [
    'ux',
    'summernote',
    'ui.ace'
])
    .config(function ($stateProvider) {
        $stateProvider
            .state('configuration', {
                url: '/config',
                abstract: true,
                views: {
                    'header': {
                        templateUrl: '/common/header/appHeader.tpl.html',
                        controller: 'appHeaderController'
                    },
                    'content': {
                        templateUrl: '/configuration/configuration.tpl.html'
                    }
                }
            })
            .state('configuration.rulesBrowser', {
                url: '/rule/browser',
                views: {
                    'view': {
                        templateUrl: '/configuration/rulesBrowser/rulesBrowser.tpl.html',
                        controller: 'rulesBrowserController'
                    }
                }
            })
            .state('configuration.ruleBuilder', {
                url: '/rule/:ruleId',
                views: {
                    'view': {
                        templateUrl: '/configuration/ruleBuilder/ruleBuilder.tpl.html',
                        controller: 'ruleBuilderController'
                    }
                }
            })
            .state('configuration.formTemplateBrowser', {
                url: '/template/browser',
                views: {
                    'view': {
                        templateUrl: '/configuration/formTemplateBrowser/formTemplateBrowser.tpl.html',
                        controller: 'formTemplateBrowserController'
                    }
                }
            })
            .state('configuration.dataSetBrowser', {
                url: '/dataSet/browser',
                views: {
                    'view': {
                        templateUrl: '/configuration/dataSetBrowser/dataSetBrowser.tpl.html',
                        controller: 'dataSetBrowserController'
                    }
                }
            })
            .state('configuration.dataSetEditor', {
                url: '/dataSet/:dataSetName/:type',
                views: {
                    'view': {
                        templateUrl: '/configuration/dataSetEditor/dataSetEditor.tpl.html',
                        controller: 'dataSetEditorController'
                    }
                }
            })
            .state('configuration.dataSetEditor.dataItems', {
                url: '/dataItems',
                views: {
                    'tabView': {
                        templateUrl: '/configuration/dataSetEditor/content/dataItems/dataItems.tpl.html',
                        controller: 'dataItemsController'
                    }
                }
            })
            .state('configuration.dataSetEditor.dynamicCriteria', {
                url: '/dynamicCriteria',
                views: {
                    'tabView': {
                        templateUrl: '/configuration/dataSetEditor/content/dynamicCriteria/dynamicCriteria.tpl.html',
                        controller: 'dynamicCriteriaController'
                    }
                }
            })
            .state('configuration.dataSetEditor.repeatingForm', {
                url: '/repeatingForm',
                views: {
                    'tabView': {
                        templateUrl: '/configuration/dataSetEditor/content/repeatingForm/repeatingForm.tpl.html',
                        controller: 'repeatingFormController'
                    }
                }
            })
            .state('configuration.formEditor', {
                url: '/template/:uiFormTemplateId',
                abstract: true,
                views: {
                    'view': {
                        templateUrl: '/configuration/formEditor/formEditor.tpl.html',
                        controller: 'formEditorController'
                    }
                }
            })
            .state('configuration.formEditor.form', {
                url: '/builder',
                views: {
                    'tabView': {
                        templateUrl: '/configuration/formEditor/content/form/formBuilder.tpl.html',
                        controller: 'formBuilderController'
                    }
                }
            })
            .state('configuration.formEditor.rules', {
                url: '/rules/:ruleName',
                params: {
                    ruleName: {value: null, squash: true}
                },
                views: {
                    'tabView': {
                        templateUrl: '/configuration/formEditor/content/rule/formRules.tpl.html',
                        controller: 'formRulesController'
                    }
                }
            })
            .state('configuration.formEditor.preview', {
                url: '/preview',
                views: {
                    'tabView': {
                        templateUrl: '/configuration/formEditor/content/preview/formPreview.tpl.html'
                    }
                }
            })
            .state('configuration.productTemplateBrowser', {
                url: '/productTemplate/browser',
                views: {
                    'view': {
                        templateUrl: '/configuration/productTemplateBrowser/productTemplateBrowser.tpl.html',
                        controller: 'productTemplateBrowserController'
                    }
                }
            })
            .state('configuration.productTemplateEditor', {
                url: '/productTemplate/:productTemplateName/:productTemplateId',
                params: {
                    productTemplateName: {value: null, squash: true},
                    productTemplateId: {value: null, squash: true}
                },
                views: {
                    'view': {
                        templateUrl: '/configuration/productTemplateEditor/productTemplateEditor.tpl.html',
                        controller: 'productTemplateEditorController'
                    }
                }
            })
            .state('configuration.permissionsEditor', {
                url: '/permissions/:userType',
                views: {
                    'view': {
                        templateUrl: '/configuration/permissionsEditor/permissionsEditor.tpl.html',
                        controller: 'permissionsEditorController'
                    }
                }
            })
            .state('configuration.organizationBrowser', {
                url: '/organization/browser/:organizationType',
                views: {
                    'view': {
                        templateUrl: '/configuration/organizationBrowser/organizationBrowser.tpl.html',
                        controller: 'organizationBrowserController'
                    }
                }
            })
            .state('configuration.manageOrganization', {
                url: '/organization/manage/:organizationType/:organizationId',
                params: {
                    organizationId: {
                        value: null,
                        squash: true
                    },
                    organizationType: {
                        value: null,
                        squash: true
                    }
                },
                views: {
                    'view': {
                        templateUrl: '/configuration/organizationBrowser/manageOrganization/manageOrganization.tpl.html',
                        controller: 'manageOrganizationController'
                    }
                }
            })
            .state('configuration.manageOrganization.form', {
                url: '/form/:formId',
                params: {
                    formId: {
                        value: null,
                        squash: true
                    }
                },
                views: {
                    'mainContent': {
                        templateUrl: '/configuration/organizationBrowser/manageOrganization/formViewer/manageOrganizationFormViewer.tpl.html',
                        controller: 'manageOrganizationFormViewerController'
                    }
                }
            })
            .state('configuration.manageOrganization.formSummaryGridDetail', {
                url: '/form/:formId/detail/:ownerUriId/:formSummaryInstanceId',
                views: {
                    'mainContent': {
                        templateUrl: '/formViewer/component/formSummary/detail/formSummaryGridDetail.tpl.html',
                        controller: 'formSummaryGridDetailController'
                    }
                },
                resolve: {
                    effectiveDate: function () {
                        return {
                            get: function () {
                                return null;
                            }
                        };
                    },
                    currencyCode: function () {
                        return {
                            get: function () {
                                return null;
                            }
                        };
                    },
                    printable: function () {
                        return {
                            get: function () {
                                return false;
                            }
                        };
                    }
                }
            })
            .state('configuration.emailBrowser', {
                url: '/notification/email/browser',
                views: {
                    'view': {
                        templateUrl: '/configuration/emailNotification/emailNotificationBrowser.tpl.html',
                        controller: 'emailNotificationBrowserController'
                    }
                }
            })
            .state('configuration.manageEmail', {
                url: '/notification/email/manage/:templateId',
                params: {
                    templateId: { value: null, squash: true }
                },
                views: {
                    'view': {
                        templateUrl: '/configuration/emailNotification/manageEmailNotification/manageEmailNotification.tpl.html',
                        controller: 'manageEmailNotificationController'
                    }
                }
            })
            .state('configuration.popupBrowser', {
                url: '/notification/popup/browser',
                views: {
                    'view': {
                        templateUrl: '/configuration/popupNotification/popupNotificationBrowser.tpl.html',
                        controller: 'popupNotificationBrowserController'
                    }
                }
            })
            .state('configuration.managePopup', {
                url: '/notification/popup/manage/:templateId',
                params: {
                    templateId: { value: null, squash: true }
                },
                views: {
                    'view': {
                        templateUrl: '/configuration/popupNotification/managePopupNotification/managePopupNotification.tpl.html',
                        controller: 'managePopupNotificationController'
                    }
                }
            })
            .state('configuration.sectionTemplateBrowser', {
                url: '/sectionTemplate/browser',
                views: {
                    'view': {
                        templateUrl: '/configuration/sectionTemplateBrowser/sectionTemplateBrowser.tpl.html',
                        controller: 'sectionTemplateBrowserController'
                    }
                }
            })
            .state('configuration.sectionTemplateEditor', {
                url: '/sectionTemplate/:sectionTemplateId',
                views: {
                    'view': {
                        templateUrl: '/configuration/sectionTemplateEditor/sectionTemplateEditor.tpl.html',
                        controller: 'sectionTemplateEditorController'
                    }
                }
            })
            .state('configuration.sectionTemplateEditor.properties', {
                url: '/properties',
                views: {
                    'tabView': {
                        templateUrl: '/configuration/sectionTemplateEditor/content/properties/sectionTemplateProperties.tpl.html',
                        controller: 'sectionTemplatePropertiesController'
                    }
                }
            })
            .state('configuration.sectionTemplateEditor.rule', {
                url: '/rule',
                views: {
                    'tabView': {
                        templateUrl: '/configuration/sectionTemplateEditor/content/rule/sectionTemplateRule.tpl.html',
                        controller: 'sectionTemplateRuleController'
                    }
                }
            })
            .state('configuration.systemPreferencesManager', {
                url: '/generalPreferences/manager',
                views: {
                    'view': {
                        templateUrl: '/configuration/systemPreferencesManager/systemPreferencesManager.tpl.html',
                        controller: 'systemPreferencesManagerController'
                    }
                }
            })
			.state('configuration.scoringRulesBrowser', {
                url: '/scoringRules/browser',
                views: {
                    'view': {
                        templateUrl: '/configuration/scoringRules/scoringRulesBrowser.tpl.html',
                        controller: 'scoringRulesBrowserController'
                    }
                }
            })
            .state('configuration.manageScoringRules', {
                url: '/manageScoringRules/:scoringRuleId/',
                views: {
                    'view': {
                        templateUrl: '/configuration/scoringRules/manageScoringRules/manageScoringRules.tpl.html',
                        controller: 'manageScoringRulesController'
                    }
                }
            })
            .state('configuration.rateStatus', {
                url: '/rateStatus/manager',
                views: {
                    'view': {
                        templateUrl: '/configuration/rateStatus/rateStatus.tpl.html',
                        controller: 'rateStatusController'
                    }
                }
            })
            .state('configuration.filesAndIconsManager', {
                url: '/filesAndIcons/manager',
                views: {
                    view: {
                        templateUrl: '/configuration/filesAndIconsManager/filesAndIconsManager.tpl.html',
                        controller: 'filesAndIconsManagerController'
                    }
                }
            })
            .state('configuration.defaultHomePage', {
                url: '/default/defaultHomePage',
                views: {
                    'view': {
                        templateUrl: '/configuration/defaultHomePage.tpl.html'
                    }
                }
            });
    })
    .value('configurationConstant', {
        event: {
            OPTION_GROUP_INPUT_VALUE_CHANGED: 'configurationConstant.OptionGroupInputValueChanged',
            FORM_COMPONENT_SELECTED: 'configurationConstant.FormComponentSelected',
            FIELD_COMPONENT_SELECTED: 'configurationConstant.FieldComponentSelected',
            SELECTOR_WIDGET_UPDATED: 'selectorWidgetUpdated',
            DATA_SET_EDITOR_MODEL_UPDATED: 'configurationConstant.DataSetEditorModelUpdated',
            DATA_SET_ITEM_DRAG_DROP: 'configurationConstant.DataSetItemDragDrop',
            DATA_SET_ITEMS_GROUP_DRAG_DROP: 'configurationConstant.DataSetItemsGroupDragDrop',
            DATA_SET_ITEM_DRAG_DROP_FROM_UNSELECTED_ROW: 'configurationConstant.DataSetItemDragDropFromUnselectedRow',
            DATA_SET_ITEMS_GROUP_DRAG_DROP_FROM_UNSELECTED_GROUP: 'configurationConstant.DataSetItemsGroupDragDropFromUnselectedRow',
            DATA_SET_ITEM_GROUP_SET_SHIFT_SELECT_PIVOT: 'configurationConstant.DataSetItemGroupSetShiftSelectPivot',
            DATA_SET_ITEMS_GROUP_UPDATED: 'configurationConstant.DataSetItemsGroupUpdated',
            DATA_SET_SOURCE_FIELD_DEPENDENCY_UPDATED: 'configurationConstant.DataSetSourceFieldDependencyUpdated',
            DATA_SET_DYNAMIC_CRITERIA_UPDATED: 'configurationConstant.DataSetDynamicCriteriaUpdated',
            DATA_SET_DEPENDENCIES_UPDATED: 'configurationConstant.DataSetDependenciesUpdated',
            RULE_MODEL_UPDATED: 'configurationConstant.RuleModelUpdated',
            PRODUCT_TEMPLATE_UPDATED: 'configurationConstant.ProductTemplateUpdated',
            EMAIL_TEMPLATE_UPDATED: 'configurationConstant.EmailTemplateUpdated',
            PERMISSIONS_UPDATED: 'configurationConstant.PermissionsUpdated',
            SECTION_TEMPLATE_EDITOR_MODEL_UPDATED: 'configurationConstant.SectionTemplateEditorModelUpdated',
            SYSTEM_PREFERENCES_MANAGER_MODEL_UPDATED: 'configurationConstant.SystemPreferencesManagerModelUpdated',
            SCORING_RULE_UPDATED: 'configurationConstant.ScoringRuleUpdated',
            STATE_RATE_DELETED: 'configurationConstant.StateRateDeleted',
            STATE_RATE_COPY: 'configurationConstant.StateRateCopy',
            STATE_RATE_ROW_CLICKED: 'configurationConstant.StateRateRowClicked',
            FILES_AND_ICONS_MANAGER_MODEL_UPDATED: 'configurationConstant.FilesAndIconsManagerModelUpdated'
        },
        dataSet: {
            INSERT_BEFORE: 'configurationConstant.DataSetInsertBefore',
            INSERT_AFTER: 'configurationConstant.DataSetInsertAfter',
            MAX_SOURCE_FIELD_DEPENDENCIES: 3
        }
    })
    .value('emailEditorConstant', {
        event: {
            EMAIL_UPDATE_COMPLETE: 'emailEditorModule.EmailUpdateComplete',
            PEOPLE_LIST_LOADED:'emailModule.PeopleListLoaded'
        }
    })
    .run(function () {
    });

require('./configuration.tpl.html');
require('./configurationMediator.js');

require('./defaultHomePage.tpl.html');

require('./dataSetBrowser/dataSetBrowser.i18n.json');
require('./dataSetBrowser/dataSetBrowser.tpl.html');
require('./dataSetBrowser/dataSetBrowserController.js');
require('./dataSetBrowser/dataSetBrowserActionRepository.js');

require('./dataSetEditor/dataSetEditor.tpl.html');
require('./dataSetEditor/dataSetEditorController.js');
require('./dataSetEditor/header/dataSetEditorHeaderComponent.js');
require('./dataSetEditor/nav/dataSetEditorNavComponent.js');
require('./dataSetEditor/content/dataItems/dataItems.i18n.json');
require('./dataSetEditor/content/dataItems/dataItems.tpl.html');
require('./dataSetEditor/content/dataItems/dataItemsController.js');
require('./dataSetEditor/content/dataItems/uiDeleteDataItemsAndGroupsDirective.js');
require('./dataSetEditor/content/dataItems/dataItemsGroup/dataItemsGroupComponent.js');

require('./dataSetEditor/content/dynamicCriteria/dynamicCriteriaController.js');
require('./dataSetEditor/content/dynamicCriteria/dynamicCriteria.i18n.json');
require('./dataSetEditor/content/dynamicCriteria/dynamicCriteria.tpl.html');
require('./dataSetEditor/content/dynamicCriteria/dynamicDataItemCriterion/dynamicDataItemCriterionComponent.js');
require('./dataSetEditor/content/dynamicCriteria/sourceFieldDependency/sourceFieldDependencyComponent.js');

require('./dataSetEditor/content/repeatingForm/repeatingFormController.js');
require('./dataSetEditor/content/repeatingForm/repeatingForm.i18n.json');
require('./dataSetEditor/content/repeatingForm/repeatingForm.tpl.html');

require('./dataSetReferences/dataSetReferencesController.js');
require('./dataSetReferences/dataSetReferences.i18n.json');
require('./dataSetReferences/dataSetReferencesModal.tpl.html');

require('./dataSetSettings/dataSetSettings.i18n.json');
require('./dataSetSettings/dataSetSettingsController.js');
require('./dataSetSettings/dataSetSettingsTemplate.tpl.html');

require('./emailNotification/emailNotificationBrowserController.js');
require('./emailNotification/manageEmailNotification/manageEmailNotificationController.js');

require('./fieldReferences/fieldReferences.i18n.json');
require('./fieldReferences/fieldReferencesController.js');
require('./fieldReferences/fieldReferencesModal.tpl.html');
require('./fieldReferences/fieldReferencesRepository.js');

require('./formEditor/formEditor.tpl.html');
require('./formEditor/formEditorController.js');
require('./formEditor/uiFormTemplateModel.js');
require('./formEditor/header/formEditorHeaderComponent.js');
require('./formEditor/nav/formEditorNavComponent.js');

require('./formReferences/formReferences.i18n.json');
require('./formReferences/formReferencesModal.tpl.html');
require('./formReferences/formReferencesController.js');
require('./formReferences/formReferencesRepository.js');

require('./formTemplateBrowser/formTemplateBrowser.i18n.json');
require('./formTemplateBrowser/formTemplateBrowser.tpl.html');
require('./formTemplateBrowser/formTemplateBrowserController.js');
require('./formTemplateBrowser/formTemplateBrowserActionRepository.js');
require('./formTemplateBrowser/formTemplateSetRepository.js');
require('./reloadRulesModal/reloadRulesModal.tpl.html');
require('./reloadRulesModal/reloadRulesModalController.js');

require('./formTemplateSettings/formTemplateSettings.i18n.json');
require('./formTemplateSettings/formTemplateSettingsTemplate.tpl.html');
require('./formTemplateSettings/formTemplateSettingsController.js');

require('./manageOperation/manageOperationComponent.js');

require('./javaScriptExpression/javaScriptExpression.i18n.json');
require('./javaScriptExpression/javaScriptExpressionTemplate.tpl.html');
require('./javaScriptExpression/javaScriptExpressionController.js');

require('./multiStepSelectorWidget/multiStepSelectorWidgetComponent.js');
require('./organizationBrowser/organizationBrowserController.js');
require('./permissionsEditor/permissionsEditorController.js');
require('./productTemplateBrowser/productTemplateBrowserController.js');
require('./productTemplateEditor/productTemplateEditorController.js');
require('./popupNotification/popupNotificationBrowserController.js');
require('./popupNotification/managePopupNotification/notificationPopupTemplateModel.js');
require('./regularExpression/regularExpressionController.js');
require('./repo/objectRepository.js');
require('./ruleBuilder/ruleBuilderController.js');
require('./rulesBrowser/rulesBrowserController.js');
require('./ruleTemplateSettings/ruleTemplateSettingsController.js');
require('./util/sectionTemplateEditorModel.js');

require('./scoringRules/scoringRulesBrowserController.js');
require('./scoringRules/manageScoringRules/manageScoringRulesController.js');
require('./scoringRules/header/scoringRulesEditorHeaderComponent.js');

require('./rateStatus/rateStatusController.js');
require('./rateStatus/rateStatusRow/umRateStatusRowDomManager.js');

require('./sectionTemplateBrowser/sectionTemplateBrowserController.js');
require('./sectionTemplateEditor/sectionTemplateEditorController.js');
require('./systemPreferencesManager/systemPreferencesManagerController.js');
require('./uploadDocument/uploadDocumentModalController.js');
require('./filesAndIconsManager/filesAndIconsManagerController.js');
require('./util/configurationActionsUtil.js');
require('./util/dataItemSortingConstant.js');
require('./util/dataSetEditorModel.js');
require('./util/dataSetManagementUtil.js');
require('./util/sectionTemplateEditorModel.js');

module.exports = 'ums.configuration';
